import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=128d5e2e&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=128d5e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128d5e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128d5e2e')) {
      api.createRecord('128d5e2e', component.options)
    } else {
      api.reload('128d5e2e', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=128d5e2e&scoped=true&", function () {
      api.rerender('128d5e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading/Loading.vue"
export default component.exports